module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAhklEQVR4AWOgC7gjLoOM3NedhyM0KQo1SJGkQVjmWZTEPRXpO6JEaAAqui0o82ml8CM7qdu8xNnwxEfyTbPo8xTxe2rShDXclZT5uET4bY/op7XCj90libBBQubjMuGPK4W/7BF65CxJlA2v68Re5oi/aRN9aC1FlB9A/haWuSNC9YgblAAAIwPJsvcm3bsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MN.png
// module id = 1210
// module chunks = 0